import { inviteRoom } from '../../../../services/room.service'

export const inviteRoomActions = {
  [inviteRoom.fulfilled]: (state, { payload }) => {
    const { room } = payload.response
    state.room.splice(payload.idx, 1, room)
  }
}
